import { UAnimatedIcon } from './icons';

export const animatedIconUrl = (icon: UAnimatedIcon) => {
  return `assets/animated_widget_icons/${icon}.svg`;
};
